

















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { gsap } from "gsap";
import IconBase from "@/common/components/atoms/IconBase.vue";
import TextLabelNewArrivalCount from "@/common/components/atoms/TextLabelNewArrivalCount.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";

import commons from "@/common/store/modules/commons";

@Component({
  components: {
    IconBase,
    TextLabelNewArrivalCount,
    IconArrowBottom
  }
})
export default class NaviListLinkOnAdmin extends Vue {
  @Prop({ type: String, default: "/", required: true }) url!: string;
  @Prop({ type: Number, required: true }) currentElementKey!: number;
  @Prop({ type: [Array, Boolean], required: true }) childList!: any;
  @Prop({ type: Boolean, required: true }) shown!: boolean;
  @Prop({ type: [Number, String, Boolean], required: true }) hasNotification!: [
    number,
    string,
    boolean
  ];

  @Prop({ type: Number, default: 0 }) thanksPointCount!: number;

  get colorCode() {
    return commons?.colorCode;
  }

  get adminNotificationCount() {
    return commons?.userInfo.notification_count.admin;
  }

  defaultHoverColor = "#3c3c3c";
  hoverColor: any = {
    currentHover: "this.defaultHoverColor"
  };

  get notificationCount() {
    return this.thanksPointCount;
  }

  @Watch("shown")
  onShown() {
    this.startRotateAnimationOfArrowElement();
  }

  emitMouseover() {
    this.hoverColor.currentHover = this.colorCode;
    // const currentElementKey = this;
    // const hoverColor = this;
    // const colorCode = this;
    // this.hoverColor.currentHover = colorCode;
    // this.$emit("on-mouseover", currentElementKey);
  }

  emitMouseleave() {
    this.hoverColor.currentHover = "black";
    // const hoverColor: any = this;
    // const defaultHoverColor = hoverColor;
    // hoverColor.currentHover = defaultHoverColor;
    // this.$emit("on-mouseover", -1);
  }

  emitClick() {
    this.$emit("on-click", this.currentElementKey);
  }

  startRotateAnimationOfArrowElement() {
    const { shown } = this;
    const { arrowElement } = this.$refs;
    const speed = 0.15;
    if (!arrowElement) return false;

    gsap.to(arrowElement, speed, {
      rotate: shown ? -180 : 0
    });
    return true;
  }

  // getNotificationCount() {
  //   const self = this;
  //   const adminNotificationCount: any = self;
  //   const hasNotification = self;
  //   const childList = self;
  //   const getNotificationValueType = typeof hasNotification;
  //   const initNotification : any = {
  //     boolean() {
  //       const resultCount = hasNotification;

  //       if (hasNotification) {
  //         const totalCount = self.getTotalCountOfNotification(
  //           hasNotification,
  //           childList
  //         );
  //         return totalCount > 0 ? totalCount : false;
  //       }

  //       return resultCount;
  //     },

  //     string() {
  //       const resultCount = adminNotificationCount[hasNotification];
  //       return resultCount > 0 ? resultCount : false;
  //     }
  //   };

  //   this.notificationCount = initNotification[getNotificationValueType]();
  // }

  getTotalCountOfNotification(notification: any, child: any) {
    const adminNotificationCount = notification;
    const childList = child;
    let total = 0;

    for (
      let childListIndex = 0;
      childListIndex < childList.length;
      childListIndex += 1
    ) {
      const hasNotificationString = childList[childListIndex].hasNotification;
      if (hasNotificationString !== false && adminNotificationCount) {
        const resultCount = adminNotificationCount[hasNotificationString];
        total += parseInt(resultCount, 10);
      }
    }

    return total > 0 ? total : false;
  }
}
